import { render } from "./Wage.vue?vue&type=template&id=24f508f6&scoped=true"
import script from "./Wage.vue?vue&type=script&lang=js"
export * from "./Wage.vue?vue&type=script&lang=js"

import "./Wage.vue?vue&type=style&index=0&id=24f508f6&lang=scss&scoped=true"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f508f6"]])

export default __exports__